







import TheLayoutMobile from "./TheLayoutMobile.vue";
import TheLayout from "./TheLayout.vue";
import ResponsiveLayout from "../mixin/ResponsiveLayout.vue";

export default {
  components: {
    ResponsiveLayout,
    TheLayoutMobile,
    TheLayout,
  },
  data() {
    return {
      TheLayout,
      TheLayoutMobile,
    };
  }
};
